/**
 * Opens the account portal from URLs and editor-authored links.
 *
 * Two hooks for content the theme editor produces: `?modal=account` on page load, and any link
 * whose href ends in `#join` or `#account` (richtext, buttons, the PDP USP messages). Logged-in
 * customers have no portal in the DOM, so their click goes to the account page instead.
 */
const ACCOUNT_LINK_SELECTOR = 'a[href$="#join"], a[href$="#account"]'
const ACCOUNT_URL = '/account'

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search)
  const modalParam = params.get('modal')

  if (modalParam === 'account') {
    openLoginDrawer()
  }
})

document.addEventListener('click', (event) => {
  const link = event.target.closest?.(ACCOUNT_LINK_SELECTOR)
  if (!link) return

  event.preventDefault()
  if (window.GM_STATE?.customer?.logged) {
    window.location.assign(ACCOUNT_URL)
    return
  }
  openLoginDrawer()
})

const openLoginDrawer = () => {
  // sections/account-drawer.liquid is rendered once from the layout, so there is a single `account`
  // modal to open. Called directly rather than via the show event so the URL is never touched.
  const modal = document.querySelector('x-modal[data-id="account"]')
  if (modal?.handleShow) {
    modal.handleShow()
    return
  }
  const accountTrigger = document.querySelector('[data-modal-parent="account"][data-modal-role="open"]')
  if (accountTrigger) {
    accountTrigger.click()
  }
}

window.openLoginDrawer = openLoginDrawer
